module.exports = __webpack_public_path__ + "static/everhealth_logo_black-f04e501b243b744ab6c28a9de6197805.png";